import Checkbox from '@repo/ui/checkbox'
import React, { useEffect, useState } from 'react'

type Props = {
  disabled?: boolean
  value: boolean
  onChange: (value: boolean) => Promise<void>
}

const CheckboxStatefulInput: React.FC<Props> = ({ disabled, value, onChange }) => {
  const [checked, setChecked] = useState(value)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setChecked(value)
  }, [value])

  return (
    <Checkbox
      checked={checked}
      disabled={disabled}
      // loading={loading}
      onChange={() => {
        if (loading) return
        setLoading(true)
        const newValue = !checked
        setChecked(newValue)
        onChange(newValue)
          .catch(() => setChecked(!newValue))
          .finally(() => setLoading(false))
      }}
    />
  )
}

export default CheckboxStatefulInput
